import projects from './projects.reducer';
import project from './project.reducer';
import questionnaire from './questionnaire/questionnaire.reducer';
import loading from './loading.reducer';
import perfeed from './perfeed';

import { combineReducers } from 'redux';
import { OutputReportReducer } from '../../actions/OutputReportActions';

export default combineReducers({
    projects,
    project,
    questionnaire,
    loading,
    perfeed,
    report: OutputReportReducer,
});
